var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.paragraphType === 'string')?_c('p',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.$t(_vm.content))}}):_vm._l((_vm.content),function(paragraph,i){return _c('p',{key:i,staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.$t(paragraph))}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }